import { Fragment } from "react";
import { Link } from "react-router-dom";
// import { motion } from "framer-motion";
import css from "./Breadcrumbs.module.scss";

// const animations = {
//    initial: { opacity: 0 },
//    animate: { opacity: 1 },
//    exit: { opacity: 0 },
// };

export default function Breadcrumbs({ path }) {
   // remove trailing backslash: page/sub-page/ => page/sub-page
   if (path !== "/") {
      path = path.replace(/\/$/, ""); 
   }

   let routes = path.split("/");
   
   routes.shift(); // remove first empty element of homepage

   let currentPage = routes.pop();

   // make the link readable
   function convert(path) {
      return decodeURIComponent(path.replace(/-/g, " ").replace(/oe/g, "ö").replace(/ae/g, "ä").replace(/ue/g, "ü"));
   }

   if (routes[routes.length - 1] == "items" || routes[routes.length - 1] == "offers") {
      currentPage = "Details" // A Hacky wat to remove item/offer id in the breadcrumbs
   }
   else if(routes[0] === "confirmation") {
      routes.pop(); //Removes the hash
   }

   return (
      // <motion.div
      <div
         // variants={animations}
         // initial="initial"
         // animate="animate"
         // exit="exit"
         className={css["breadcrumbs"]}
         // key="hallo"
      >
         {routes.map((path, index) => {
            let url = "/" + routes.slice(0, index + 1).join("/");
            return (
               <Fragment key={url}>
                  <Link to={url} >
                     {convert(path)}
                  </Link>
                  <i className="fa fa-chevron-right" />
               </Fragment>
            );
         })}

         <span>{convert(currentPage)}</span>
      {/* </motion.div> */}
      </div>
   );
}
